import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Switch } from "../../../../components/ui/switch";
import { Label } from "../../../../components/ui/label";
import {
  Select, SelectTrigger, SelectValue, SelectContent,
  SelectItem, SelectGroup, SelectLabel,
} from "../../../../components/ui/select";
import { limitTowingStorageOptions } from "data"; // <- from your data file
import { FieldError } from "../FieldError";

export function LimitsSection() {
  const { control, watch, setValue, trigger } = useFormContext();

  // Show TGL P&NC only when TGL coverage is selected (matches your screenshots)
  const hasTGL = watch("step8.truckers_general_liability");

  // If TGL turns OFF, clear its P&NC switch so state stays clean
  React.useEffect(() => {
    if (!hasTGL) setValue("step8.limits.primaryNoncontribTGL", false, { shouldDirty: true });
  }, [hasTGL, setValue]);

  React.useEffect(() => {
    trigger("step8.limits");
  }, []);
  return (
    <section className="rounded-xl">
      <h3 className="text-xl font-semibold mb-4">Limits</h3>

      {/* Waiver of Subrogation */}
      <div className="flex items-center gap-3 pb-4">
        <Controller
          control={control}
          name="step8.limits.waiverSubrogation"
          render={({ field }) => (
            <Switch id="limit-waiver" checked={!!field.value} onCheckedChange={field.onChange} />
          )}
        />
        <Label htmlFor="limit-waiver" className="cursor-pointer">
          Do you need Waiver Subrogation?
        </Label>
        <FieldError name="step8.limits.waiverSubrogation" step={"step8"} />
      </div>

      {/* Primary & Noncontributory for TGL (conditional) */}
      {hasTGL && (
        <div className="flex items-center gap-3 pb-4">
          <Controller
            control={control}
            name="step8.limits.primaryNoncontribTGL"
            render={({ field }) => (
              <Switch id="limit-pnc-tgl" checked={!!field.value} onCheckedChange={field.onChange} />
            )}
          />
          <Label htmlFor="limit-pnc-tgl" className="cursor-pointer">
            Do you need Primary and Noncontributory for TGL?
          </Label>
          <FieldError name="step8.limits.primaryNoncontribTGL" step={"step8"} />
        </div>
      )}

      {/* Primary & Noncontributory for AL (always visible per screenshots) */}
      <div className="flex items-center gap-3 pb-4">
        <Controller
          control={control}
          name="step8.limits.primaryNoncontribAL"
          render={({ field }) => (
            <Switch id="limit-pnc-al" checked={!!field.value} onCheckedChange={field.onChange} />
          )}
        />
        <Label htmlFor="limit-pnc-al" className="cursor-pointer">
          Do you need Primary and Noncontributory for AL?
        </Label>
        <FieldError name="step8.limits.primaryNoncontribAL" step={"step8"} />
      </div>

      {/* Towing, Labor & Storage Limit (required) */}
      <div className="space-y-2">
        <Label>
          Towing, Labor and Storage Limit <span className="text-red-600">*</span>
        </Label>
        <Controller
          control={control}
          name="step8.limits.towingLimit"
          render={({ field, fieldState }) => (
            <>
              <Select
                value={(field.value) ?? "unselected"}
                onValueChange={field.onChange}
                onOpenChange={() => field.onChange(field.value)}
              >
                <SelectTrigger className="w-full !h-10 py-2 px-3">
                  <SelectValue placeholder="Select a limit" />
                </SelectTrigger>
                <SelectContent className="max-h-60 overflow-y-auto">
                  <SelectGroup>
                    <SelectLabel>Limit</SelectLabel>
                    <SelectItem value="unselected">Select a limit</SelectItem>
                    {limitTowingStorageOptions.map((o) => (
                      // store label or value — if you prefer numeric strings in state, switch to value={o.value}
                      <SelectItem key={o.value} value={o.value}>
                        {o.label}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
              {fieldState.error && (
                <p className="text-xs text-red-600 mt-1">{fieldState.error.message}</p>
              )}
            </>
          )}
        />
        <FieldError name="step8.limits.towingLimit" step={"step8"} />
      </div>
    </section>
  );
}
